module.exports = __webpack_public_path__ + "media/jazz.7742788e.mp3";